function getCurrencySymbol (currency) {
  const val = 0

  return val.toLocaleString('en', { style: 'currency', currency }).replace(/\d+([,.]\d+)?/g, '')
}

export { getCurrencySymbol }
